import {
  Condition,
  SubjectLineMatchType,
} from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import {
  ConditionType,
  ConditionTypeDetailsProps,
} from "../../return-flow/condition";
import { displayStringForMatchCondition } from "../rule-utils";

export type SubjectLineState = Required<Omit<Condition.SubjectLine, "type">>;

export const SUBJECT_LINE = (
  Details: React.ComponentType<ConditionTypeDetailsProps<SubjectLineState>>,
): ConditionType<SubjectLineState, Condition.SubjectLine> => ({
  name: "Subject line",
  description(state) {
    return displayStringForMatchCondition(
      "Subject line",
      state.matchMode,
      state.queryStrings,
    );
  },
  Details(props: ConditionTypeDetailsProps<SubjectLineState>) {
    return React.createElement(Details, props);
  },
  empty: {
    fuzzy_match: "",
    queryStrings: [],
    caseSensitive: false,
    matchMode: SubjectLineMatchType.CONTAINS,
  },
  fromModel(model) {
    return {
      ...model,
      queryStrings: model.queryStrings || [model.fuzzy_match || ""],
      caseSensitive: model.caseSensitive ?? false,
      matchMode: model.matchMode ?? SubjectLineMatchType.CONTAINS,
    };
  },
  toModel(state) {
    return { type: Condition.SUBJECT_LINE, ...state };
  },
  valid() {
    return true;
  },
});
